import { render } from "./bookForm.vue?vue&type=template&id=4dd1c77d&scoped=true"
import script from "./bookForm.vue?vue&type=script&lang=js"
export * from "./bookForm.vue?vue&type=script&lang=js"

import "./bookForm.vue?vue&type=style&index=0&id=4dd1c77d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd1c77d"]])

export default __exports__